import _Model from "./_Model";

export default class OutdatedLicense extends _Model {
  constructor(json) {
    super(json);
    this.oldLicense = OutdatedLicense.getOrDefault(json, 'oldLicense', null);
    this.newLicense = OutdatedLicense.getOrDefault(json, 'newLicense', null);
    this.outdatedType = OutdatedLicense.getOrDefault(json, 'outdatedType', null);
  }
}
